const ERROR = {
  NO_HISTORY_API: 'This browser does not support the History API',
};

const query = {
  get(getOriginal = false) {
    return window.location.search.substring(getOriginal ? 0 : 1);
  },
  parse() {
    const result = {};
    query.get()
      .split('&')
      .forEach((queryStr) => {
        if (queryStr) {
          const duo = queryStr.split('=');
          result[duo[0]] = duo[1];
        }
      });
    return result;
  },
  encode(queries) {
    return `?${Object.keys(queries)
      .map(key => `${key}=${queries[key]}`)
      .join('&')}`;
  },

  /**
   * Append or replace new query string to the url.
   * @param {object} newQueries - a key-value paired object
   */
  add(newQueries) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    const existingQueries = query.parse();
    Object.keys(newQueries).forEach((key) => {
      existingQueries[key] = newQueries[key];
    });
    const newPathName = path.build(null, query.encode(existingQueries));
    history.replaceState({}, null, newPathName);
  },

  /**
   * Replace query string with the provided value
   * @param {object} newQueries - a key-value paired object
   */
  set(newQueries) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    const newPathName = path.build(null, query.encode(newQueries));
    history.replaceState({}, null, newPathName);
  },

  /**
   * Remove a query and its value
   * @param {string} keyToDelete - name of the key
   */
  remove(keyToDelete) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    const existingQueries = query.parse();
    delete existingQueries[keyToDelete];
    const newPathName = path.build(null, query.encode(existingQueries));
    history.replaceState({}, null, newPathName);
  },
};

const path = {
  get(getOriginal = false) {
    return window.location.pathname.substring(getOriginal ? 0 : 1);
  },
  build(newPath, newQuery, newHash) {
    newPath = newPath || path.get();
    newQuery = newQuery || query.get(true);
    newHash = newHash || window.location.hash;

    return `/${newPath}${newQuery}${newHash}`;
  },
  update(newPath) {
    if (window.history) {
      const newPathName = path.build(newPath);
      history.replaceState({}, null, newPathName);
    }
  },
};

export default {
  query,
  path,
};



// WEBPACK FOOTER //
// ./src/utils/urlParser.js